import React, { useEffect, useState } from "react";
import { HtmlHTMLAttributes } from "react";
import { UtilityService } from "../../services/UtilityService";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"

interface IAvatarProps extends HtmlHTMLAttributes<"div"> {
    Name: string;
    PhoneNumber?: string;
    Index?: number;
    Size?: number;
    AspectRatio?: number;
    ImgSrc?: string;
}


const defaultProps = {
    Name: "U K",
    Size: 40,
    AspectRatio: 2.5
}

const Avatar: React.FunctionComponent<IAvatarProps> = (props: IAvatarProps) => {
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const [url, setUrl] = useState("")

    const colors = IsDarkMode ? ["#B14056", "#9F823D", "#2B8A7B", "#6D3D82", "#41588D"] : ["#FFE4E9", "#F2EAD6", "#D3F1EC", "#F6E2FF", "#E2EBFF"]

    const textcolors = IsDarkMode ? ["#FFE4E9", "#F2EAD6", "#D3F1EC", "#F6E2FF", "#E2EBFF"] : ["#B14056", "#9F823D", "#2B8A7B", "#6D3D82", "#41588D"]

    let nameParts = props.Name.toUpperCase().split(" ");

    let initials = UtilityService.getInitials(nameParts[0], nameParts[1]).replace(/ /g, "");

    let hashIndex = UtilityService.getHashIndex(props.PhoneNumber ? props.PhoneNumber : props.Name.toUpperCase(), colors.length);
    // let backgroundColor = props.ImgSrc ? "#ffffff00" : colors[props.Index ? (props.Index + hashIndex) % colors.length : hashIndex];
    let backgroundColor = props.Index !== undefined ? colors[props.Index < colors.length ? props.Index : props.Index % colors.length] : colors[hashIndex]

    let style = {
        backgroundColor,
        fontSize: (props.Size || defaultProps.Size) / (props.AspectRatio || defaultProps.AspectRatio),
        width: props.Size || defaultProps.Size,
        height: props.Size || defaultProps.Size,
        color: props.Index !== undefined ? textcolors[props.Index < textcolors.length ? props.Index : props.Index % textcolors.length] : textcolors[hashIndex]
    };

    useEffect(() => {
        if (!props.ImgSrc) return;

        UtilityService.convertUrlToBlob(props.ImgSrc).then(res => {
            if (res) {
                setUrl(res);
            }
        });
    }, [props.ImgSrc]);

    return <div className={`avatar ${props.className || ""}`} style={style}>
        {
            props.ImgSrc ?
                <img width={props.Size || defaultProps.Size} height={props.Size || defaultProps.Size} style={{ borderRadius: "100%", maxWidth: "100%" }} src={url} alt="Avatar" />
                :
                <span className="m-auto">{initials}</span>
        }
    </div>
}

Avatar.defaultProps = defaultProps;

export default Avatar;